import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'wifi-0', 'IconWifi0', [["path",{"d":"M12 18l.01 0","key":"svg-0"}]]);